import React, { PureComponent } from 'react';
import classnames from 'classnames';
import ChoroplethMapWidget from '~/core/scripts/widgets/ChoroplethMapWidget';

const basemapAttribution = 'Karte: <a href="https://www.maptiler.com/license/maps/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>';

class BrexitMap extends PureComponent {
  constructor() {
    super();

    this.state = {
      isSoftBrexit: false
    }
  }

  handleHardBrexit() {
    this.setState({ isSoftBrexit: false });
  }

  handleSoftBrexit() {
    this.setState({ isSoftBrexit: true });
  }

  render() {
    const { isSoftBrexit } = this.state;

    const HardBrexitButtonClasses = classnames('btn', { active: !isSoftBrexit });
    const SoftBrexitButtonClasses = classnames('btn', { active: isSoftBrexit });

    const valueKey = isSoftBrexit ? 'soft_loss_per_head' : 'hard_loss_per_head';
    const valueKeyabs = isSoftBrexit ? 'soft_loss_total' : 'hard_loss_total';

    return (
      <div className="brexit-map-wrapper">

        <div className="brexit-map-controls">
          <div className="btn-group horizontal">
            <button onClick={() => this.handleHardBrexit()} className={HardBrexitButtonClasses}>Harter Brexit</button>
            <button onClick={() => this.handleSoftBrexit()} className={SoftBrexitButtonClasses}>Weicher Brexit</button>
          </div>
        </div>

        <ChoroplethMapWidget
          minZoom={3}
          maxZoom={10}
          choroplethSource="data/europe.topo.json"
          overlaySource="data/europe.topo.json"
          overlayDissolveKey="country"
          showBasemap
          basemapUrl="https://api.maptiler.com/maps/c5d6c562-6f05-4f08-98c6-7c9731262035/256/{z}/{x}/{y}.png?key=68ErAz6zqgdV9jEjhpuz"
          basemapAttribution={basemapAttribution}
          showGeocoder
          valueKeyabs={valueKeyabs}
          valueKey={valueKey}
          colorSteps={[      
            [-1600, '#99000d'],
            [-1000, '#cb181d'],
            [-800, '#ef3b2c'],
            [-400, '#fb6a4a'],
            [-200, '#fc9272'],
            [-100, '#fcbba1'],
            [-50, '#fee0d2'],
            [-25, '#fff5f0'],
            [0]
          ]}
          showLegend
          legendMinLabel="-2821 Euro"
          legendMaxLabel="-5 Euro"
          showLabels
          labelPreset="germany"
          customLabels={[]}
          searchPresets={[{ name: 'Hamburg', locationId: 'NT_XIIiPCDkZjsN9RlMdvhL9C' }, { name: 'Berlin', locationId: 'NT_DKX2wfaWICS7JyfHmCOJhB' }, { name: 'London', locationId: 'NT_8aidN3RJWm1w3xJzo7emZB' }]}
          searchPresetsTitle="Zum Beispiel:"
        />

      </div>
    );
  }
}

export default BrexitMap;
